export interface DataListModel<T = any> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export interface ListResults<T> {
  count: number;
  last_evaluated_key: string | null;
  warnings: string[];
  results: T[];
}

/**
 * Pagination metadata returned by V3 API endpoints.
 */
export interface PaginationV3Model {
  total: number;
  limit: number;
  offset: number;
  current_page: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
}

/**
 * Paginated list response structure for V3 API endpoints.
 */
export interface ListResultsV3<T> {
  count: number;
  total_count?: number;
  pagination: PaginationV3Model;
  warnings: string[];
  last_evaluated_key?: string | null;
  results: T[];
}

/**
 * Pagination metadata specific to the Products V3 API endpoint.
 */
export interface ProductPaginationV3Model {
  total_records: number;
  total_pages: number;
  current_page: number;
  page_size: number;
  has_next: boolean;
  has_previous: boolean;
}

/**
 * Paginated list response structure for Products V3 API endpoint.
 */
export interface ProductListResultsV3<T> {
  count: number;
  total_count: number;
  pagination: ProductPaginationV3Model;
  warnings: string[];
  results: T[];
}

